import React from 'react';

//payment methods according to https://dermpro.atlassian.net/browse/SM-2538
const merchants = {
  bluepay_payment: {
    title: 'BluePay',
    link: 'https://secure.bluepay.com/login'
  },
  modmed_payment: {
    title: 'ModMed',
    link: ''
  },
  nextech_payment: {
    title: 'Nextech',
    link: 'https://nextechsupport.force.com/nextech/s/login/'
  },
  cc_split: {
    title: 'Stripe',
    link: 'https://dashboard.stripe.com/login'
  },
  cc_saved_split: {
    title: 'Stripe',
    link: 'https://dashboard.stripe.com/login'
  },
  mr_quadpay: {
    title: 'ZIP',
    link: 'https://customer.quadpay.com/en-US/login'
  },
  paypal_express: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  wps_express: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  wps_express_bml: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  paypal_express_bml: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  paypal_direct: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  paypal_payment_pro: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  payflow_express: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  payflow_express_bml: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  payflowpro: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  payflow_link: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  payflow_advanced: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  hosted_pro: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  paypal_billing_agreement: {
    title: 'PayPal',
    link: 'https://www.paypal.com/us/signin'
  },
  simpay_payment: {
    title: 'Simpay',
    link: 'https://secure.simpaygateway.net'
  }
};


const PaymentMerchants = ({paymentMethod}) => {
  return (
    <div className="flex items-center justify-evenly">
      {(paymentMethod == 'cc_split' || paymentMethod == 'cc_split') &&
        <a
          href={merchants['bluepay_payment'].link}
          target="_blank"
          rel="noopener noreferrer"
          title={merchants['bluepay_payment'].title}
        >
          <img
            src={`/assets/images/merchants/${merchants['bluepay_payment'].title}.png`}
            alt={merchants['bluepay_payment'].title}
            className="max-w-200"
          />
        </a>
      }
      <a
        href={merchants[paymentMethod].link}
        target="_blank"
        rel="noopener noreferrer"
        title={merchants[paymentMethod].title}
      >
        <img
          src={`/assets/images/merchants/${merchants[paymentMethod].title}.png`}
          alt={merchants[paymentMethod].title}
          className="max-w-200"
        />
      </a>
    </div>
  );
};

export default PaymentMerchants;
